/// This file was generated DO NOT MODIFY
/// Source: BudgetType.cs
/// Tool: http://frhagn.github.io/Typewriter/pages/documentation.html

export enum BudgetTypeEnum {
  Detailed = 'Detailed', //1
  Summary = 'Summary', //2
  
}
